export {default} from './EditTeam';



// WEBPACK FOOTER //
// ./src/pages/EditTeam/index.ts